<template>
    <div class="field-container cta-field field-recaptcha" v-if="!disabled">
        <div class="form-group" :id="field_id">
            <vue-recaptcha ref="recaptcha" class="recaptcha-field" :class="{ 'is-invalid': v.$error, 'is-valid': !v.$error && !v.$invalid }" :sitekey="$variables.recaptcha_key" :loadRecaptchaScript="true" @verify="onVerify" @expired="onExpired"></vue-recaptcha>
            <transition name="fade">
                <div class="invalid-feedback" key="required" v-if="!v.required">{{ $t('i18n.fieldIsRequired') }}</div>
            </transition>
        </div>
    </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: "",
        },
        v: {
            type: Object,
            required: true,
        },
        field_id: {
            type: String,
            required: true,
        }        
    },
    components: {
        VueRecaptcha,
    },
    methods: {
        onVerify: function (response) {
            this.v.$touch();
            console.log(response)
            this.$emit("input", response);
        },
        onExpired: function () {
            this.v.$touch();
            this.$emit("input", '');
        },
        resetRecaptcha() {
            this.$refs.recaptcha.reset();
        },
    },
};
</script>